import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    Mutable
} from "../../../../types";
import type {
    MarkdownEditorToolbarDynamicStyleType
} from "../../type";

const stylesheet = StyleSheet.create({
    container: {
        alignItems: "stretch"
    },
    items: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap"
    },
    scrollItems: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "nowrap"
    },
    frame: {
        position: "relative"
    },
    separator: {
        flexShrink: 0
    },
    fade: {
        bottom: 0,
        top: 0
    }
});

export const useStyles = ({
    isAtBottom,
    iconSizes,
    borders,
    colors,
    spaces
}: MarkdownEditorToolbarDynamicStyleType) => {
    const styles = {
        separator: {
            backgroundColor: colors.content.border.subtle,
            marginHorizontal: spaces.spacingXs,
            height: iconSizes.medium,
            width: borders.separator
        },
        container: {
            borderColor: colors.content.border.subtle,
            paddingHorizontal: spaces.spacingSm,
            paddingVertical: spaces.spacingXs
        } as Mutable<ViewStyle>,
        fade: {
            width: spaces.spacingXl
        },
        items: {
            gap: spaces.spacingXxs
        }
    };

    if(isAtBottom) {
        styles.container.borderTopWidth = borders.separator;
    } else {
        styles.container.borderBottomWidth = borders.separator;
    }

    return styles;
};
export default stylesheet;
